<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">DATA IDENTITAS</h6>
    
        <b-row>
            <b-col lg="4" md="6">
                <b-form-group label="Nama Anggota">
                    <b-form-input
                        v-model="dataIdentitas.nama"
                        name="namaKtp"
                        required
                        :disabled="isEdit"
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Jenis Kelamin">
                    <b-form-select v-model="dataIdentitas.jenisKelamin" name="jenisKelamin" :options="jenisKelaminOpt" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Status Pekawinan">
                    <b-form-select v-model="dataIdentitas.statusKawin" name="statusKawin" :options="statusKawinOpt" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kewarganegaraan">
                    <b-form-select v-model="dataIdentitas.kewarganegaraan" name="kewarganegaraan" :options="kewarganegaraanOpt" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Tempat Lahir">
                    <div class="d-flex">
                        <multiselect
                            name="kotaTempatLahir"
                            v-model="dataIdentitas.kotaLahir" 
                            :options="kotaLahir" 
                            :internal-search="false"
                            :loading="isLoading"
                            @search-change="searchTempatLahir"
                            :allow-empty="false"
                            :preserve-search="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="*Ketik min. 4 huruf untuk mencari..."
                        />
                    </div>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Tanggal Lahir">
                    <b-form-input v-model="dataIdentitas.tanggalLahir" name="tglLahirKtp" type="date" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kota">
                    <div class="d-flex">
                        <multiselect
                            name="kota"
                            v-model="dataIdentitas.kotaKtp" 
                            :options="kota" 
                            :internal-search="false"
                            :loading="isLoadingKota"
                            @search-change="searchTempat"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="*Ketik min. 4 huruf untuk mencari..."
                        />
                    </div>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kecamatan">
                    <b-input-group>
                        <b-form-select v-if="dataIdentitas.kecLoading == true" v-model="data" name="kecamatanKtp" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataIdentitas.kecamatanKtp" name="kecamatanKtp" :options="dataIdentitas.listKecamatan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataIdentitas.loadKecFail == true">
                            <b-button variant="primary" size="sm" @click="loadKecamatan"><i class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kelurahan">
                    <b-input-group label="Kelurahan">
                        <b-form-select v-if="dataIdentitas.kelLoading == true" v-model="data" name="kelurahanKtp" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataIdentitas.kelurahanDesaKtp" name="kelurahanKtp" :options="dataIdentitas.listKelurahan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-input-group-append v-if="dataIdentitas.loadKelFail == true">
                            <b-button variant="primary" size="sm" @click="loadKelurahan"><i class="fa fa-refresh"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6" class="form-tworow-wrapper">
                <b-row>
                    <b-col cols="6">
                        <b-form-group label="RT">
                            <b-form-input v-model="dataIdentitas.rtKtp" name="noRtKtp" maxlength="3" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="RW">
                            <b-form-input v-model="dataIdentitas.rwKtp" name="noRwKtp" maxlength="3" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Alamat KTP">
                    <b-form-textarea v-model="dataIdentitas.alamatKtp" name="alamatKtp" required maxlength="255"></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label>Alamat Tempat Kerja <span class="text-danger">*Opsional</span></label>
                    <b-form-textarea v-model="dataIdentitas.alamatKerja" maxlength="100" name="alamatTempatKerja"></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group>
                    <label>No. Telp. Tempat Kerja <span class="text-danger">*Opsional</span></label>
                    <b-form-textarea v-model="dataIdentitas.telpKerja" maxlength="40" name="telpTempatKerja"></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Pekerjaan">
                    <b-form-select v-model="dataIdentitas.pekerjaanBaru" name="pekerjaan" :options="pekerjaanOpt" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button name="identitasResetBtn" variant="danger" @click="$emit('reset')">Reset Identitas</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name: 'data-identitas',
    props: {
        dataIdentitas: { type: Object, required: true },
        dataJenisIdentitas: { type: Array, required: true },
        isEdit: { type: Boolean, default: false },
    },
    data(){
        return{
            isLoading: false,
            isLoadingKota: false,
            activeSearch: null,
            activeSearchKota: null,
            data: null,
            kota: [],
            kotaLahir: [],

            jenisKelaminOpt: [
                {value:"L" ,text:"Laki-laki"},
                {value:"P" ,text:"Perempuan"},
            ],
            statusKawinOpt: [
                {value:"BK" , text: "Belum Kawin"},
                {value:"KA" , text: "Kawin"},
                {value:"CH" , text: "Cerai Hidup"},
                {value:"CM" , text: "Cerai Mati"},
            ],
            kewarganegaraanOpt: [
                {value:"WNI" , text: "WNI"},
                {value:"WNA" , text: "WNA"},
            ],
            pekerjaanOpt : [
                // {value:1 , text: "Pegawai"},
                // {value:"Lainnya" , text: "Lainnya"},
            ],
        }
    },
    watch: {
        "dataIdentitas.rtKtp": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataIdentitas.rtKtp = result);
        },
        "dataIdentitas.rwKtp": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataIdentitas.rwKtp = result);
        },
    },
    methods: {
        
        init() {

            let getPekerjaan = this.$axios.get("nasabah-pekerjaan/selection/").then(response => {
                this.pekerjaanOpt = []
                for(var data of response.data){
                    this.pekerjaanOpt.push({value: data.id , text:data.name})
                }
                // this.pekerjaanOpt = response.data
                // console.log(this.pekerjaanOpt);
            })

            Promise.all([getPekerjaan]).then(() => {
                this.initStatus = 1
                // this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        searchTempatLahir(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoading = true

                if (this.activeSearch == null) this.activeSearch = setTimeout(() => { this.searchKotaLahir(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearch)
                    this.activeSearch = setTimeout(() => { this.searchKotaLahir(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearch)
                this.activeSearch = null
                this.isLoading = false
            }
        },

        searchKotaLahir(searchQuery){ 
            this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                this.kotaLahir = response.data
                this.isLoading = false
                this.activeSearch = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },


        searchTempat(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKota = true

                if (this.activeSearchKota == null) this.activeSearchKota = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKota)
                    this.activeSearchKota = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKota)
                this.activeSearchKota = null
                this.isLoadingKota = false
            }
        },

        searchKota(searchQuery){ 
            this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                this.kota = response.data
                this.isLoadingKota = false
                this.activeSearchKota = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        loadKecamatan(){
            this.dataIdentitas.kecLoading = true
            this.dataIdentitas.loadKecFail = false

            this.$axios.get(`area/kecamatan/${this.dataIdentitas.kotaKtp.id}`).then(response => {
                this.dataIdentitas.listKecamatan = response.data
                this.dataIdentitas.kecLoading = false
            })
            .catch(error => {
                console.log(error)
                this.input.dataIdentitas.loadKecFail = true
                this.dataIdentitas.kecLoading = false

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        loadKelurahan(){
            this.dataIdentitas.kelLoading = true
            this.dataIdentitas.loadKelFail = false

            this.$axios.get(`area/kelurahan/${this.dataIdentitas.kecamatanKtp}`).then(response => {
                this.dataIdentitas.listKelurahan = response.data
                this.dataIdentitas.kelLoading = false
            })
            .catch(error => {
                console.log(error)
                this.input.dataIdentitas.loadKelFail = true
                this.dataIdentitas.kelLoading = false

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },
    },

    created(){
        this.init()
    }
}
</script>
